// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"40de22a4","485":"b0ef0833"}[chunkId] + ".chunk.js";
};